import { createScopeFromContext, useBunja } from 'bunja/react';
import { createContext } from 'react';

import {
  instantFlipActionBunja,
  type InstantFlipVariables,
} from '@flipster/features/src/shared/trade-actions/flip/state';
import { useOverlay } from '@flipster/overlay';
import { detailBunja } from '@flipster/r230522/original/details';
import { useLoading } from '@flipster/react/misc/lifecycle/loading';

import InstantFlipModal from './index';

export const InstantFlipContext = createContext<undefined | { symbol: string; slot: number }>(undefined);
export const InstantFlipScope = createScopeFromContext(InstantFlipContext);

/**
 * Instant flip 모달의 UI 오케스트레이션 훅.
 * 실행 로직(API/토스트/에러 정책)은 instantFlipActionBunja(features/trade-actions)로 위임하고,
 * 여기선 모달 오픈·per-instance 로딩(행 단위 독립 스피너)만 담당한다.
 *
 * 반환하던 currentPosition은 소비처가 없어 제거했다 — openPositionsAtom 통구독이 소비 컴포넌트를
 * 소켓 tick마다 리렌더시켰기 때문. 모달 내부는 instantFlipModalBunja의 currentPositionAtom을 직접 구독한다.
 */
export const useInstantFlipModal = () => {
  const overlay = useOverlay();
  const { triggerSymbolUpdate } = useBunja(detailBunja);
  const { instantFlip } = useBunja(instantFlipActionBunja);

  const onOpenInstantFlipModal = (symbol: string, slot: number) => {
    triggerSymbolUpdate(symbol);
    overlay.open(({ isOpen, onClose, unmount }) => (
      <InstantFlipContext value={{ symbol, slot }}>
        <InstantFlipModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
      </InstantFlipContext>
    ));
  };

  const [isFlipLoading, startFlipLoading] = useLoading();

  return {
    onOpenInstantFlipModal,
    isFlipLoading,
    instantFlip: (params: InstantFlipVariables) => startFlipLoading(() => instantFlip(params)),
  };
};
